<template>
  <div>
    <div class="d-flex flex-row align-center mb-4">
      <h3 class="font-weight-bold secondary--text mb-1">{{ $t('label.paymentMethod') }}</h3>
    </div>
    <section class="white px-2">
      <v-radio-group v-model="selectedPaymentMethod" class="white">
        <v-card color="white" elevation="4" v-for="paymentMethod in paymentMethods" :key="paymentMethod.value" class="mb-5">
          <div class="pa-4 d-flex flex-row justify-space-between align-center">
            <div class="d-flex flex-row align-center">
              <v-radio :value="paymentMethod.value" style="background-color: #fff" @click="select(paymentMethod)"></v-radio>
              <div
                class="rounded"
                style="border: 1px solid #efefef"
                :class="{
                  'mx-4': $vuetify.breakpoint.smAndUp,
                  'mx-2': !$vuetify.breakpoint.smAndUp
                }"
              >
                <div class="white d-flex rounded">
                  <v-img
                    :src="paymentMethod.symbol"
                    :style="{ maxWidth: paymentMethod.value === 'stripe' ? ($vuetify.breakpoint.smAndUp ? '200px' : '100px') : '100px' }"
                    style="object-fit: cover; height: auto"
                    class="white"
                  ></v-img>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-radio-group>
    </section>
  </div>
</template>

<script>
import atomeLogo from '@/assets/atome.png'
import stripeLogo from '@/assets/stripeCard.png'
import stripeGrabLogo from '@/assets/stripeGrabLogo.png'

export default {
  name: 'PaymentMethods',
  data() {
    return {
      paymentMethods: [
        /*
        {
          value: 'asiapay',
          symbol: asiaPayLogo
        },
        */
        {
          value: 'stripe',
          symbol: stripeLogo,
          paymentMethod: 'card'
        },
        {
          value: 'stripeGrab',
          symbol: stripeGrabLogo,
          paymentMethod: 'grabpay'
        },
        {
          value: 'atome',
          symbol: atomeLogo,
          paymentMethod: 'atome'
        }
      ],
      selectedPaymentMethod: ''
    }
  },
  methods: {
    select(method) {
      this.$emit('payment-method', method)
    }
  }
}
</script>
<style lang="scss" scoped>
.v-radio .theme--light {
  background-color: #fff !important;
}

::v-deep .v-input--selection-controls__input > i {
  background-color: #fff !important;
}

::v-deep .v-btn {
  background-color: #fff !important;
}

::v-deep .v-input__control > .theme--light {
  background-color: #fff !important;
}
</style>
